<app-button-bg class="header" img="/assets/img/game/call-file-bg.svg" br="5em">
  <div class="btn-inside">
    <div class="right-btn-part">
      <div class="close-btn" (click)="onCloseClick()"></div>
      <div class="text">Call File</div>
    </div>
    <img class="pmi-logo" src="/assets/img/game/pmi-logo.svg">
  </div>
</app-button-bg>
<div class="content" *ngIf="shops$ | async as shops">
  <div class="left-column">
    <app-box [color]="'#475160'" [title]="'Retailer Counter'">
      <div class="box-inside">
        <div class="chosen-existing">{{ chosenExisting }}</div>
        <div class="slash pink"></div>
        <div class="max-existing">15</div>
        <div class="prospects-box">
          <div class="title">New Prospects</div>
          <div class="chosen-prospects">{{ chosenProspects }}</div>
          <div class="slash green"></div>
          <div class="max-prospects">5</div>
        </div>
      </div>
    </app-box>
    <div class="arrow-wrap">
      <img *ngIf="!gridView" class="rotated arrow" src="assets/img/game/arrow-right.svg" (click)="prevShop()">
      <!-- <img *ngIf="!gridView && (+currentShop === 1)" class="rotated arrow" src="assets/img/game/arrow-right-disabled.svg"> -->
    </div>
    
    <div class="submit-button-wrap">
      <div
        class="submit-button"
        [ngClass]="chosenExisting === 15 && chosenProspects === 5 ? '' : 'disabled'"
        (click)="endQuarter()"
      >Submit Selection</div>
    </div>
  </div>
  <swiper-container #swiperCallFile init="false" [ngStyle]="{display: gridView ? 'none' : ''}">
    <swiper-slide *ngFor="let shop of shops; index as i" [attr.data-swiper-slide-index]="i">
      <app-shop-card [shopId]="toString(i+1)"></app-shop-card>
    </swiper-slide>
  </swiper-container>
  <div class="tiles-wrap" *ngIf="gridView">
    <ng-container *ngFor="let shop of shops; index as i">
      <app-shop-tile [shopId]="toString(i+1)"></app-shop-tile>
    </ng-container>
  </div>
  <div class="right-column">
    <div class="view-button">
      <ng-container *ngIf="!gridView">
        <img src="assets/img/game/card-view-disabled.svg">
        <img src="assets/img/game/grid-view-active.svg" (click)="gridView = !gridView">
      </ng-container>
      <ng-container *ngIf="gridView">
        <img src="assets/img/game/card-view-active.svg" (click)="gridView = !gridView">
        <img src="assets/img/game/grid-view-disabled.svg">
      </ng-container>
    </div>
    <div class="arrow-wrap" *ngIf="numberShops$ | async as shopsNumber">
      <img *ngIf="!gridView" class="arrow" src="assets/img/game/arrow-right.svg" (click)="nextShop()">
      <!-- <img *ngIf="!gridView && (+currentShop === shopsNumber)" class="arrow" src="assets/img/game/arrow-right-disabled.svg"> -->
    </div>
    <div></div>
  </div>
  <div *ngIf="!gridView" class="shop-counter"><span class="pink" style="margin-right: 0.35em">{{ currentShop }}</span>/ 40</div>
</div>
